export default __webpack_public_path__ + "static/media/unacast-symbol-arctic_green-rgb.a6307ab4.svg";